module.exports = __webpack_public_path__ + "img/borderGardenWhite.eaa988e7.svg";